var map = {
	"./en/ar-3d.json": [
		3038,
		38
	],
	"./en/cad-cnc.json": [
		3176,
		176
	],
	"./en/colors.json": [
		2365,
		365
	],
	"./en/from-scan-to-kitchen.json": [
		5064,
		64
	],
	"./en/index.json": [
		955,
		955
	],
	"./en/kitchen-2025.json": [
		9129,
		129
	],
	"./en/kitchen-trends-2026.json": [
		903,
		903
	],
	"./en/materials.json": [
		533,
		533
	],
	"./sr/ar-3d-planiranje-enterijera.json": [
		1973,
		973
	],
	"./sr/cad-cnc.json": [
		4626,
		626
	],
	"./sr/colors.json": [
		3607,
		607
	],
	"./sr/from-scan-to-kitchen.json": [
		3518,
		518
	],
	"./sr/index.json": [
		8561,
		561
	],
	"./sr/kitchen-2025.json": [
		8155,
		155
	],
	"./sr/kitchen-trends-2026.json": [
		3013,
		13
	],
	"./sr/materials.json": [
		1471,
		471
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1409;
module.exports = webpackAsyncContext;